const TRUCK_WHEEL_RADIUS = 0.52;
const TRUCK_TYRE_WIDTH = 0.295;
const DUAL_SPACING = 0.36;
const DUAL_HALF_TRACK = 0.9;
const STEER_HALF_TRACK = 1.02;
const TRUCK_6_10_CROSSMEMBERS = [0.9, 0.1, -0.9, -1.9, -2.9];
const axleHalfTrack = (d, axle) => {
  var _a;
  return (_a = axle.halfTrack) != null ? _a : axle.fitment === "dual" ? d.dualHalfTrack : d.steerHalfTrack;
};
const lastAxle = (d) => {
  var _a;
  return (_a = d.axles[d.axles.length - 1]) != null ? _a : d.axles[0];
};
const TRUCK_6 = {
  length: 7.5,
  bodyWidth: 2.44,
  cabWidth: 2.32,
  cabLength: 2.1,
  cabFloorY: 0.88,
  cabRoofY: 2.85,
  chassisY: 1.2,
  wheelRadius: TRUCK_WHEEL_RADIUS,
  tyreWidth: TRUCK_TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 2.4 },
    { fitment: "dual", x: -2.05 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: TRUCK_6_10_CROSSMEMBERS,
  cargo: { frontX: 1.6, rearX: -3.6, floorY: 1.2, wallHeight: 0.72 },
  windscreenLower: [3.7, 2.23],
  windscreenUpper: [3.45, 2.79],
  sideWindow: { frontX: 3.4, rearX: 1.95, lowY: 1.9, highY: 2.62 }
};
const TRUCK_10 = {
  length: 8.6,
  bodyWidth: 2.48,
  cabWidth: 2.34,
  cabLength: 2.15,
  cabFloorY: 0.88,
  cabRoofY: 2.95,
  chassisY: 1.22,
  wheelRadius: TRUCK_WHEEL_RADIUS,
  tyreWidth: TRUCK_TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 2.95 },
    { fitment: "dual", x: -1.35 },
    { fitment: "dual", x: -2.7 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: TRUCK_6_10_CROSSMEMBERS,
  cargo: { frontX: 2.1, rearX: -3.95, floorY: 1.22, wallHeight: 1.05 },
  windscreenLower: [4.25, 2.33],
  windscreenUpper: [4, 2.89],
  sideWindow: { frontX: 3.95, rearX: 2.45, lowY: 2, highY: 2.72 }
};
const TRUCK_12 = {
  length: 10,
  bodyWidth: 2.48,
  cabWidth: 2.34,
  cabLength: 2.15,
  cabFloorY: 0.88,
  cabRoofY: 2.95,
  chassisY: 1.22,
  wheelRadius: TRUCK_WHEEL_RADIUS,
  tyreWidth: TRUCK_TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 3.55 },
    { fitment: "single", x: 2.15 },
    { fitment: "dual", x: -2.05 },
    { fitment: "dual", x: -3.4 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: [4.1, 2.8, 1.5, 0.2, -1.1, -2.4, -3.7, -4.5],
  cargo: { frontX: 1.75, rearX: -4.35, floorY: 1.22, wallHeight: 1 },
  windscreenLower: [4.95, 2.33],
  windscreenUpper: [4.7, 2.89],
  sideWindow: { frontX: 4.65, rearX: 3.15, lowY: 2, highY: 2.72 }
};
const TRUCK_16 = {
  length: 11.4,
  bodyWidth: 2.48,
  cabWidth: 2.34,
  cabLength: 2.15,
  cabFloorY: 0.88,
  cabRoofY: 2.95,
  chassisY: 1.22,
  wheelRadius: TRUCK_WHEEL_RADIUS,
  tyreWidth: TRUCK_TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 4.05 },
    { fitment: "single", x: 2.62 },
    { fitment: "dual", x: -1.1 },
    { fitment: "dual", x: -2.45 },
    { fitment: "dual", x: -3.8 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: [4.7, 3.3, 1.9, 0.5, -0.9, -2.3, -3.7, -5.1],
  cargo: { frontX: 2.05, rearX: -5.05, floorY: 1.22, wallHeight: 1 },
  windscreenLower: [5.65, 2.33],
  windscreenUpper: [5.4, 2.89],
  sideWindow: { frontX: 5.35, rearX: 3.85, lowY: 2, highY: 2.72 }
};
const TRUCK_6_THREE_SINGLE = {
  length: 8.6,
  bodyWidth: 2.48,
  cabWidth: 2.34,
  cabLength: 2.15,
  cabFloorY: 0.88,
  cabRoofY: 2.95,
  chassisY: 1.22,
  wheelRadius: TRUCK_WHEEL_RADIUS,
  tyreWidth: TRUCK_TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 2.95 },
    { fitment: "single", x: -0.4 },
    { fitment: "single", x: -2.7 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: TRUCK_6_10_CROSSMEMBERS,
  cargo: { frontX: 2.1, rearX: -3.95, floorY: 1.22, wallHeight: 1.05 },
  windscreenLower: [4.25, 2.33],
  windscreenUpper: [4, 2.89],
  sideWindow: { frontX: 3.95, rearX: 2.45, lowY: 2, highY: 2.72 }
};
const TRUCK_4 = {
  length: 5.4,
  bodyWidth: 1.85,
  cabWidth: 1.78,
  cabLength: 1.55,
  cabFloorY: 0.62,
  cabRoofY: 2.15,
  chassisY: 0.88,
  wheelRadius: 0.38,
  tyreWidth: 0.22,
  axles: [
    { fitment: "single", x: 1.55, halfTrack: 0.78 },
    { fitment: "single", x: -1.55, halfTrack: 0.78 }
  ],
  steerHalfTrack: 0.78,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: [1.4, 0.2, -1, -2],
  cargo: { frontX: 1.15, rearX: -2.55, floorY: 0.88, wallHeight: 0.55 },
  windscreenLower: [2.65, 1.55],
  windscreenUpper: [2.48, 2.08],
  sideWindow: { frontX: 2.42, rearX: 1.35, lowY: 1.35, highY: 1.95 }
};
export {
  TRUCK_10,
  TRUCK_12,
  TRUCK_16,
  TRUCK_4,
  TRUCK_6,
  TRUCK_6_THREE_SINGLE,
  axleHalfTrack,
  lastAxle
};
